(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('[name="link_path"]').addEventListener('change', e => {
    window.location.href = e.target.value
  })

  } catch(e) { console.error(e); }
})();
})();
